/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from 'react';
import {
	Box,
	Button,
	Center,
	Container,
	Flex,
	Table,
	Tbody,
	Td,
	Text,
	Th,
	Thead,
	Tr,
	useDisclosure,
	Modal,
	ModalOverlay,
	ModalContent,
	ModalHeader,
	ModalBody,
	ModalCloseButton,
	useToast,
	AlertDialog,
	AlertDialogOverlay,
	AlertDialogContent,
	AlertDialogHeader,
	AlertDialogBody,
	AlertDialogFooter,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight, faFileAlt, faPlus } from '@fortawesome/free-solid-svg-icons';
import { useLocation, useHistory } from 'react-router-dom';
import BreadcrumbComponent from '../../../../components/BreadcrumbComponent/BreadcrumbComponent';
import PrintLayout from '../../../../components/Print/PrintLayout';
import useStore from '../../../../store/index.js';
import c from '../../../../constant';
import { gql, useLazyQuery, useMutation } from '@apollo/client';
import LabelDate from '../../../../components/LabelDate.js';
import CompanyName from '../../../../components/CompanyName.js';
import CompanyBadge from '../../../../components/Other/CompanyBadge.js';
import composeQueries from '../../../../utils/composeQueries.js';
import CreateRatioDocument from '../create-ratio-document.js';
import ReactPaginate from 'react-paginate';
import TotalRow from '../../../../components/TotalRow.js';
import { ButtonDropdown } from '@cloudscape-design/components';

const Q_STATEMENTS = gql`
	query get($pagerInput: PagerInput!, $companyId: String, $companyType: InsuranceInstitutionsType, $year: Float) {
		getAnnuallyFinancialStatementsRatio(pagerInput: $pagerInput, companyId: $companyId, companyType: $companyType, year: $year) {
			list {
				id
				company {
					id
					name
					nameKhmer
					type
					logo
				}
				year
				createdAt
				lifeReport {
					id
					companyRiskRanking
				}
				nonLifeReport {
					id
					companyRiskRanking
				}
				notification {
					read
				}
			}
			totalRows
			totalPages
		}
	}
`;

const Q_DELETE_STATEMENT = gql`
	mutation RemoveRatioStatement($id: String!) {
		removeAnnuallyFinancialStatementsRatio(id: $id)
	}
`;

function AnnualFinancialStatementRatioList({ companyType = null, getCRS = null }) {
	const toast = useToast();
	const location = useLocation();
	const { push } = useHistory();
	const deleteDialogRef = useRef();
	const deleteDialogCancelRef = useRef();
	const urlParams = new URLSearchParams(location.search);
	const page = urlParams.get('page') ? urlParams.get('page') : 1;
	const period = urlParams.get('period') || null;
	const reportId = urlParams.get('reportId') || null;
	const companyId = urlParams.get('companyId') || null;
	const report = urlParams.get('report') || null;
	const title = urlParams.get('title') || null;
	const year = urlParams.get('year') || null;
	const { t } = useTranslation();
	const { currentLang: lang } = useStore((state) => state?.currentLang);
	const [breadcrumb, setBreadcrumb] = useState([]);
	const readReport = useStore((state) => state.readReport);

	const { isOpen, onOpen, onClose } = useDisclosure();
	const [openModalView, setOpenModalView] = useState(false);
	const [modalReportType, setModalReportType] = useState(false);

	const [deletedId, setDeletedId] = useState(null);
	const [isOpeningDeleteDialog, setOpeningDeleteDialog] = useState(false);

	const [openType, setOpenType] = useState('page');
	const [fetchList, { loading: loadingGet, data: dataGet, error: errorGet }] = useLazyQuery(Q_STATEMENTS);
	const [removeRatioStatement, { loading: loadingRemoveStatement, data: dataRemoveStatement, error: errorRemoveStatement }] = useMutation(Q_DELETE_STATEMENT);

	useEffect(() => {
		load();
	}, [page, companyId, companyType, title, year, period, reportId]);

	useEffect(() => {
		if (errorGet) {
			if (errorGet?.graphQLErrors?.length > 0) {
				errorGet?.graphQLErrors.map(({ message }, i) =>
					toast({
						title: t(message),
						status: 'error',
						isClosable: true,
						position: 'bottom-right',
					})
				);
			} else {
				toast({
					title: t(errorGet?.message ? errorGet?.message : 'something went wrong'),
					status: 'error',
					isClosable: true,
					position: 'bottom-right',
				});
			}
		}
	}, [errorGet]);

	function load() {
		const limit = 10;
		const offset = parseInt(page ? (page - 1) * limit : 0) || 0;
		const variables = {
			pagerInput: { limit, offset },
			companyId,
			companyType,
			year: parseInt(year),
		};
		fetchList({ variables });
	}

	function handlePageChanged({ selected }) {
		let page = selected + 1;
		let url = '?period=' + period + '&reportId' + reportId + '&page=' + page + '&report=' + report;

		if (companyId !== null && companyId !== undefined) {
			url += `&companyId=${companyId}`;
		}

		if (companyType !== null && companyType !== undefined) {
			url += `&companyType=${companyType}`;
		}

		if (title !== null && title !== undefined) {
			url += `&title=${title}`;
		}

		if (year !== null && year !== undefined) {
			url += `&year=${year}`;
		}
		push(`/early-warning-system/annual-financial-statement-ratio/list${url}`);
	}

	function openDetail(e) {
		if (openType === 'page') {
			const companyId = e?.company?.id;
			const companyType = e?.company?.type;
			const params = '?statementId=' + e?.id + '&period=' + period + '&reportId=' + reportId + '&report=' + report + '&year=' + e?.year;
			if (e?.notification?.read === false) {
				readReport(reportId);
			}
			push('/early-warning-system/annual-financial-statement-ratio/detail' + composeQueries(params, { companyType, companyId }));
		} else {
			setOpenModalView(e?.id);
			setModalReportType(e?.reportType);
			if (e?.notification?.read === false) {
				readReport(reportId);
			}
		}
	}

	useEffect(() => {
		if (dataRemoveStatement?.removeAnnuallyFinancialStatementsRatio) {
			toast({
				title: t('Annual Financial Statement Ratio has been deleted'),
				status: 'success',
				isClosable: true,
				position: 'top-right',
			});
			onRejectDeleteDialog();
			load();
		}
	}, [dataRemoveStatement]);

	useEffect(() => {
		if (errorRemoveStatement) {
			toast({
				title: t(errorRemoveStatement.message || 'Delete failed'),
				status: 'error',
				isClosable: true,
				position: 'top-right',
			});
		}
	}, [errorRemoveStatement]);

	function onRejectDeleteDialog() {
		setOpeningDeleteDialog(false);
		setDeletedId(null);
	}

	function onApproveDeleteDialog() {
		if (!deletedId) return;
		removeRatioStatement({ variables: { id: deletedId } });
	}

	function actionMenu(row) {
		return (
			<Box onClick={(e) => e.stopPropagation()}>
				<ButtonDropdown
					className="action-button-table"
					variant="inline-icon"
					ariaLabel={t('Actions')}
					expandToViewport={true}
					items={[{ id: 'delete', text: <p style={{ color: 'red' }}>{t('Delete')}</p> }]}
					onItemClick={({ detail }) => {
						switch (detail?.id) {
							case 'delete':
								setDeletedId(row?.id);
								setOpeningDeleteDialog(true);
								break;
							default:
								break;
						}
					}}
				/>
			</Box>
		);
	}

	useEffect(() => {
		if (period && reportId) {
			setBreadcrumb([
				{
					name: 'Company Report',
					path: '/company-submission-report',
				},
				{
					name: period,
					path: `/early-warning-system?period=${period}&reportId=${reportId}&report=${report}`,
				},
				{
					name: 'Annual Financial Statement Ratio',
					path: '#',
				},
			]);
		} else {
			setBreadcrumb([
				{
					name: 'Company Report',
					path: '/company-submission-report',
				},
				{
					name: 'Annual Financial Statement Ratio',
					path: '#',
				},
			]);
		}
	}, [period, reportId]);

	return (
		<PrintLayout>
			<>
				<Container maxW="container.xl" mt="16px" mb="16px">
					<BreadcrumbComponent
						list={[
							{
								name: 'Company Report',
								path: '/company-submission-report',
							},
							{
								name: period,
								path: composeQueries('/early-warning-system?period=' + period + '&reportId=' + reportId + '&report=' + report, {
									companyType,
									companyId,
								}),
							},
							{
								name: 'Annual Key Risk Indicator',
								path: '#',
							},
						]}
					/>
					<Center className="show-only-printing">
						<Text textAlign="center" color="#62B3ED" fontFamily="Moul" fontSize={18}>
							{t('Company Report')}
						</Text>
					</Center>
					<>
						<Center mt="5">
							<Box
								w="100%"
								bg="white"
								borderRadius={c.borderRadius}
								border="1px solid #dbdbdb"
								boxShadow="0 1px 2px rgba(var(--black, #000), 0.1)"
								pb="32px"
							>
								<Flex
									className="hidden-print responsive-header-for-table"
									bg="#FAFAFA"
									p="16px"
									pt="8px"
									pb="8px"
									mb="16px"
									alignItems="center"
									justifyContent="space-between"
									borderBottom="1px solid #dbdbdb"
								>
									<Text fontSize="x-large" fontWeight="bold">
										{t('Annual Key Risk Indicator')}
									</Text>
									<Button
										className="hidden-print"
										isLoading={false}
										isDisabled={false}
										size="sm"
										leftIcon={<FontAwesomeIcon icon={faPlus} style={{ fontSize: 16 }} />}
										borderRadius={c.borderRadius}
										border="1px solid #bdc3c7"
										mr={[0, 0, 2]}
										width={['100%', '100%', 'auto']}
										colorScheme="gray"
										variant="solid"
										onClick={onOpen}
									>
										{t('Create')}
									</Button>
								</Flex>

								{!loadingGet && dataGet?.getAnnuallyFinancialStatementsRatio?.list?.length <= 0 && (
									<Flex direction="column" alignItems="center" justifyContent="center" pt={16} pl={4} pr={4} pb={16}>
										<FontAwesomeIcon icon={faFileAlt} style={{ fontSize: 56, color: '#A0AEC0' }} />
										<Text fontSize="lg" fontWeight="bold" color="gray.600" mt={6}>
											{t('No Data')}
										</Text>
									</Flex>
								)}
								{!loadingGet && dataGet?.getAnnuallyFinancialStatementsRatio?.list?.length > 0 && (
									<>
										<Table variant="simple" className="table-company-proposal-list responsive-table-container">
											<Thead>
												<Tr className="td-as-th">
													<Th align="left">{t('Company')}</Th>
													<Th align="left">{t('Type')}</Th>
													<Th align="left">{t('Year')}</Th>
													<Th align="left">{t('Risk Ranking')}</Th>
													<Th align="left">{t('Submitted At')}</Th>
													<Th align="right">{t('Action')}</Th>
												</Tr>
											</Thead>
											<Tbody>
												{dataGet?.getAnnuallyFinancialStatementsRatio?.list?.map((e, i) => {
													return (
														<Tr
															key={`report-item-${i}`}
															className={e?.notification?.read === false ? 'new' : 'read'}
															onClick={() => openDetail(e)}
														>
															<Td align="left">
																<CompanyName company={e?.company} />
															</Td>
															<Td align="left">
																<CompanyBadge type={e?.company?.type} />
															</Td>
															<Td align="left">
																<LabelDate input={parseInt(e?.year)} inputFormat="Y" outputFormat="YYYY" />
															</Td>
															<Td align="left">
																{e?.company?.type !== 'GENERAL_INSURANCE'
																	? e?.lifeReport?.companyRiskRanking
																	: e?.nonLifeReport?.companyRiskRanking}
															</Td>
															<Td align="left">
																<LabelDate input={e?.createdAt} outputFormat={c.dateTimeFormat} />
															</Td>
															<Td align="left">{actionMenu(e)}</Td>
														</Tr>
													);
												})}
											</Tbody>
											<tfoot className="responsive-footer hidden-print">
												<Tr className="td-as-th">
													<Th align="left">{t('Company')}</Th>
													<Th align="left">{t('Type')}</Th>
													<Th align="left">{t('Year')}</Th>
													<Th align="left">{t('Risk Ranking')}</Th>
													<Th align="left">{t('Submitted At')}</Th>
													<Th align="right">{t('Action')}</Th>
												</Tr>
											</tfoot>
										</Table>
									</>
								)}
							</Box>
						</Center>
					</>
					{dataGet?.getAnnuallyFinancialStatementsRatio?.totalRows > 0 && (
						<>
							<Flex justifyContent="flex-end" direction="row">
								<TotalRow count={dataGet?.getAnnuallyFinancialStatementsRatio?.totalRows} mt={2} />
							</Flex>
						</>
					)}
					{dataGet?.getAnnuallyFinancialStatementsRatio?.totalPages > 1 && (
						<>
							<Flex alignItems="flex-end" direction="column" mt={4}>
								<Flex alignItems="flex-end" direction="column">
									<ReactPaginate
										previousLabel={<FontAwesomeIcon icon={faChevronLeft} style={{ fontSize: 12, cursor: 'pointer' }} />}
										nextLabel={<FontAwesomeIcon icon={faChevronRight} style={{ fontSize: 12, cursor: 'pointer' }} />}
										breakLabel={'...'}
										breakClassName={'break-me'}
										disableInitialCallback={true}
										pageCount={dataGet?.getAnnuallyFinancialStatementsRatio?.totalPages}
										marginPagesDisplayed={2}
										pageRangeDisplayed={3}
										onPageChange={handlePageChanged}
										containerClassName={'pagination'}
										activeClassName={'active'}
										initialPage={(page - 1) | 0}
									/>
								</Flex>
							</Flex>
						</>
					)}
				</Container>

				<Modal isOpen={isOpen} onClose={onClose} size="xl">
					<ModalOverlay />
					<ModalContent borderRadius={c.borderRadius}>
						<ModalHeader>{t('New Document')}</ModalHeader>
						<ModalCloseButton />
						<ModalBody>
							<CreateRatioDocument
								period={period}
								reportId={reportId}
								companyType={companyType}
								companyId={companyId}
								title={title}
								year={year}
								onCallback={() => {
									onClose();
									load();
								}}
							/>
						</ModalBody>
					</ModalContent>
				</Modal>

				<AlertDialog isOpen={isOpeningDeleteDialog} leastDestructiveRef={deleteDialogRef} onClose={onRejectDeleteDialog}>
					<AlertDialogOverlay>
						<AlertDialogContent>
							<AlertDialogHeader fontSize="lg" fontWeight="bold">
								{t('Delete Annual Financial Ratio Statement')}
							</AlertDialogHeader>

							<AlertDialogBody>
								<Text fontSize="15px">{t("Are you sure? You can't undo this action afterwards")}</Text>
							</AlertDialogBody>
							<AlertDialogFooter>
								<Button mr={4} isLoading={loadingRemoveStatement} ref={deleteDialogCancelRef} onClick={onRejectDeleteDialog}>
									{t('Cancel')}
								</Button>
								<Button isLoading={loadingRemoveStatement} colorScheme="red" onClick={onApproveDeleteDialog}>
									{t('Confirm')}
								</Button>
							</AlertDialogFooter>
						</AlertDialogContent>
					</AlertDialogOverlay>
				</AlertDialog>
			</>
		</PrintLayout>
	);
}

export default AnnualFinancialStatementRatioList;
